import { Component } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import eventBus from "@src/helpers/events";
import { asosGlobalNamespace, sdkGlobalNamespace } from "@template/constants";

import { initialiseSecuredTouch } from "./securedTouchSDKInitialisation";

const SECUREDTOUCH_SDK_SCRIPT_URL =
  "https://st-static.asos.com/sdk/securedtouch-sdk-3.9.0w.js";

const loadScript = scriptUrl => {
  const script = document.createElement("script");
  script.src = scriptUrl;
  script.defer = true;
  document.body.appendChild(script);
};

const identityReadyHandler = () => {
  global[asosGlobalNamespace][sdkGlobalNamespace].identity.customer
    .profile()
    .then(function(response) {
      const { customerGuid, sessionId } = response;
      initialiseSecuredTouch(customerGuid, sessionId);
    });
};

class SecuredTouch extends Component {
  static propTypes = {
    securedTouchEnabled: PropTypes.bool
  };

  componentDidMount() {
    const { securedTouchEnabled } = this.props;

    if (securedTouchEnabled) {
      loadScript(SECUREDTOUCH_SDK_SCRIPT_URL);

      if (get(global[asosGlobalNamespace][sdkGlobalNamespace], "identity")) {
        identityReadyHandler();
      } else {
        eventBus.addListener("identity-sdk-ready", identityReadyHandler);
      }
    }
  }
  render() {
    return null;
  }
}

export default SecuredTouch;
